import { Button } from "theme-ui";
import { IoArrowBack } from "react-icons/io5";

export const BackButton = ({ onBack }) => {
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onBack}
      aria-label="Back"
      sx={{
        p: 2,
        m: 0,
        minWidth: "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0,
      }}
    >
      <IoArrowBack size={20} />
    </Button>
  );
};
